var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"value":_vm.modelValue,"items":_vm.items,"label":_vm.label,"outlined":"","dense":"","color":"primary"},on:{"input":function($event){return _vm.$emit('update:modelValue', $event)}}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }